import { singlePageProps } from '@lib';
import {
  Hero,
  Definitions,
  FlexibleOptions
} from '@components/features/multifactor-authentication';
import { PageProps } from '../../types/page-props';

export default function MultifactorPage(props: PageProps) {
  return (
    <>
      <Hero {...props} />
      <Definitions />
      <FlexibleOptions {...props} />
    </>
  );
}

export async function getStaticProps({ preview = false }) {
  const slug = '/features/multifactor-authentication';
  return singlePageProps({ preview, slug });
}
